import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  getTopGamesStart,
  getTopPlayersStart,
  getCurrentWinnersStart
} from 'store/redux-slices/casinoMenu'

const useTopPerformance = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { selectedLanguageCode, languageData } = useSelector((state) => state.language)
  const { topGames, topPlayers, currentWinners } = useSelector((state) => state.casinoMenu)

  useEffect(() => {
    dispatch(getTopGamesStart({ limit: 3 }))
    dispatch(getTopPlayersStart())
    dispatch(getCurrentWinnersStart({ limit: 12 }))
  }, [dispatch])

  return {
    topPlayers,
    currentWinners,
    topGames,
    languageData,
    selectedLanguageCode,
    navigate
  }
}

export default useTopPerformance
